"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class RemittanceInvoices {
}
exports.RemittanceInvoices = RemittanceInvoices;
//# sourceMappingURL=RemittanceInvoices.js.map